import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["buttonTheme", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Fab from '@mui/material/Fab';
import { BGCOLOR, ICONCOLOR, HOVERCOLOR, HOVERICONCOLOR, ACTIVECOLOR, ACTIVEICONCOLOR } from './TAGFAButton.type';

var TAGFloaterButton = function TAGFloaterButton(_ref) {
  var buttonTheme = _ref.buttonTheme,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(Fab, _objectSpread(_objectSpread({}, props), {}, {
    sx: [{
      backgroundColor: buttonTheme && BGCOLOR["".concat(buttonTheme)],
      color: buttonTheme && ICONCOLOR["".concat(buttonTheme)],
      '&:hover': {
        backgroundColor: HOVERCOLOR[buttonTheme],
        color: HOVERICONCOLOR[buttonTheme]
      },
      '&:active': {
        backgroundColor: ACTIVECOLOR[buttonTheme],
        color: ACTIVEICONCOLOR[buttonTheme],
        boxShadow: 'none'
      },
      '&.Mui-disabled': {
        //NOTE: Overrides the default font for the disabled feature and reflects what is shown on Figma design
        backgroundColor: 'neutrals.neutral',
        color: 'text.disabled'
      }
    }, sx]
  }));
};

export default TAGFloaterButton;